module.exports = __webpack_public_path__ + "img/div.9138218a.svg";